import { SideMenu } from "../../core/components/SideMenu";
import { Content } from "./Content";
import {
  Navigate,
  Outlet,
  useParams,
} from "react-router-dom";
import {ReactNode} from "react";
import classNames from "classnames";
import {AdminState, useAdminSelector} from "../../../stores/AdminStore";
import NavBar  from "../../core/components/NavBar";
import { Unauthorized } from "../../core/components/Unauthorized";
import { NavigationMenu } from "../../../models/NavigationMenu";
import { useLastPath } from "../../core/hooks/useLastPath";
import { useSlugs } from "../../core/hooks/useSlugs";
import { BreadcrumbItem } from "../models/BreadcrumbItem";
import { Breadcrumb } from "./Breadcrumb";
import {useSelector} from "react-redux";

interface ModuleProps {
  breadcrumb?: BreadcrumbItem;
  children?: ReactNode | ReactNode[];
  menu?: NavigationMenu;
  variant?: "pos" | "default";
  topBanner?: ReactNode;
}

export const Module = ({
  breadcrumb,
  children,
  menu,
  variant = "default",
  topBanner
}: ModuleProps) => {
  const lastPath = useLastPath();
  const params = useParams();
  const open = useAdminSelector(s => s.menu.open);
  const {brandSlug, locationSlug} = useSlugs();

  // Access the isModalFormOpen state from Redux
  const isModalFormOpen = useSelector((state: AdminState) => state.modalForm.isModalFormOpen);

  if (menu && !menu.items.length) {
    return (
      <Module>
        <Unauthorized/>
      </Module>
    );
  }

  if (menu) {
    if (lastPath === menu.parentPath) {
      return <Navigate to={`${menu.items[0].path}`} replace={true}/>;
    }
    else if (menu.parentPath.startsWith(":") &&
      lastPath === params[menu.parentPath.replace(":", "")]) {
      return <Navigate to={`${menu.items[0].path}`} replace={true}/>;
    }
  }

  return (
    <>
      <SideMenu menu={menu?.items ?? []}/>
      <NavBar isDisabled={isModalFormOpen}/>
      <div className={classNames(
        "fixed top-16 md:top-14 bottom-0 right-0 overflow-auto",
        open
          ? "left-80"
          : "left-0"
      )}>
        <Content variant={variant} >
          {topBanner}
          {
            !!breadcrumb &&
            <div className="mb-2 md:mb-4 flex flex-wrap items-center">
              <Breadcrumb breadcrumb={breadcrumb} isRoot={true}
                path={`/${brandSlug}/${locationSlug}/${breadcrumb.path}`}/>
            </div>
          }
          {
            children
              ? <>{children}</>
              : <Outlet />
          }
        </Content>
      </div>
    </>
  );
};
